module.exports = __webpack_public_path__ + "img/qd2.e77deff7.png";